import React, { useEffect, useMemo, useState } from "react";
import Layout from "src/components/app/layout/Layout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "src/components/app/layout/Header";
import OrderHistory from "src/constants/orderHistory";
import {
  OrderHistoryActionType,
  OrderHistoryItemData,
} from "src/types/orderHistory.types";
import Button from "src/components/app/Button";
import Card from "src/components/app/Card/Card";
import { RootState } from "src/redux/store";
import { useSelector } from "react-redux";
import { AddressListResponse } from "src/types/location.types";
import Modal from "src/components/common/Modal";
import { cancelLabTestRequest } from "src/redux/slices/labTestSlice";
import { useAppDispatch } from "src/redux/hooks";
import { toast } from "sonner";
import environment from "src/constants/environment";

interface ReasonListType {
  id: number;
  option: string;
}

const ReasonListScreen: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const supportProgramKey = params["support-program-key"];
  const actionType = params["action-type"] as OrderHistoryActionType;
  const [reasonList, setReasonList] = useState<ReasonListType[]>([]);
  const [selectedReason, setSelectedReason] = useState<number | null>(null);
  const { orderDetails } = useLocation().state as {
    orderDetails: OrderHistoryItemData;
  };
  const orderData = useSelector((state: RootState) =>
    state.orderHistory.orderHistory.data?.lab_tests.find(
      (order: OrderHistoryItemData) =>
        order.order_master_id === orderDetails.order_master_id
    )
  );
  const [cancelPopUpOpen, setCancelPopUpOpen] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const isCancelLoading = useSelector(
    (state: RootState) => state.labTest.cancelLabTest.isLoading
  );
  console.log("orderData", orderData);
  useEffect(() => {
    if (actionType) {
      const tempReasonList: ReasonListType[] =
        actionType === "reschedule"
          ? OrderHistory.RESCHEDULE_LAB_TEST.options
          : OrderHistory.CANCEL_LAB_TEST.options;
      setReasonList(tempReasonList);
    }
  }, [actionType]);

  const reasonTitle = useMemo(() => {
    return actionType === "reschedule"
      ? OrderHistory.RESCHEDULE_LAB_TEST.title
      : OrderHistory.CANCEL_LAB_TEST.title;
  }, [actionType]);

  const title = useMemo(() => {
    return actionType === "reschedule"
      ? "Reschedule Lab Test"
      : "Cancel Lab Test";
  }, [actionType]);

  const cancelOrder = () => {
    if (selectedReason) {
      //console.log(reasonList[selectedReason - 1].option);
      new Promise((resolve, reject) => {
        dispatch(
          cancelLabTestRequest({
            resolve,
            reject,
            payload: {
              dev: environment.ENV !== "prod",
              order_master_id: orderDetails.order_master_id,
              remark: reasonList[selectedReason - 1].option || "",
            },
          })
        );
      })
        .then((response) => {
          navigate(`/app/${supportProgramKey}/book-lab-test/order-details`, {
            state: {
              order_master_id: orderDetails.order_master_id,
            },
          });
          toast.success("Lab test cancelled successfully");
        })
        .catch((error) => {
          toast.error("Something went wrong");
        });
    } else {
      toast.error("Please select a reason");
    }
  };

  console.log("order data", orderData);
  return (
    <Layout supportProgramKey={supportProgramKey || ""}>
      <Header
        title={title}
        onBackClick={() =>
          navigate(`/app/${supportProgramKey}/book-lab-test/order-history`)
        }
      />
      <div className="max-w-lg mx-auto px-4 py-6 space-y-4">
        <Card stackTitleAndDescription={true}>
          <h2 className="text-lg font-semibold text-gray-700 mb-4">
            {reasonTitle}
            <span className="text-orange-500">*</span>
          </h2>

          <div className="space-y-3">
            {reasonList.map((reason) => (
              <label
                key={reason.id}
                className="flex items-center gap-2 cursor-pointer"
              >
                <input
                  type="radio"
                  name="reason"
                  value={reason.id}
                  checked={selectedReason === reason.id}
                  onChange={() => {
                    setSelectedReason(reason.id);
                  }}
                  className="form-radio text-orange-500"
                />
                <span className="text-gray-600">{reason.option}</span>
              </label>
            ))}
          </div>
        </Card>

        <Button
          //title={title}
          //onClick={onSubmit}
          onClick={() => {
            if (selectedReason) {
              if (actionType === "reschedule") {
                navigate(
                  `/app/${supportProgramKey}/book-lab-test/select-time-slot`,
                  {
                    state: {
                      orderDetails: orderDetails,
                      rescheduleReason: reasonList[selectedReason - 1].option,
                      address: {
                        address: orderData?.patient_address_data.address,
                        address_type:
                          orderData?.patient_address_data.address_type,
                        bcp_address:
                          orderData?.patient_address_data.bcp_address,
                        contact_no: orderData?.patient_address_data.contact_no,
                        name: orderData?.patient_address_data.name,
                        patient_address_rel_id:
                          orderData?.patient_address_data
                            .patient_address_rel_id,
                        patient_id: orderData?.patient_address_data.patient_id,
                        pincode: orderData?.patient_address_data.pincode,
                        street: orderData?.patient_address_data.street,
                        latitude: parseFloat(
                          orderData?.patient_address_data.latitude || "0"
                        ),
                        longitude: parseFloat(
                          orderData?.patient_address_data.longitude || "0"
                        ),
                      } as AddressListResponse,
                    },
                  }
                );
              } else {
                setCancelPopUpOpen(true);
              }
            }
          }}
          disabled={!selectedReason}
          fullWidth
        >
          {title}
        </Button>
      </div>
      {/* {cancelPopUpOpen && (
        <Modal
          show={cancelPopUpOpen}
          handleClose={() => setCancelPopUpOpen(false)}
          title="Cancel Lab Test"
          showCloseButton={true}
          //showBackButton={true}
          //backButton={<X className="w-4 h-4" />}
        >
          <div className="bg-white p-4 rounded-lg">
            <h2 className="text-lg font-semibold text-gray-700 mb-4">
              Are you sure you want to cancel this test?
            </h2>
            <div className="flex justify-end">
              <button className="bg-red-500 text-white px-4 py-2 rounded-md">
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      )} */}
      <Modal
        show={cancelPopUpOpen}
        handleClose={() => setCancelPopUpOpen(false)}
        title="Cancel Lab Test"
        showCloseButton={true}
        //showBackButton={true}
        //backButton={<X className="w-4 h-4" />}
      >
        <div className="bg-white p-4 rounded-lg">
          <h2 className="text-md font-semibold text-gray-700 mb-4">
            Are you sure you want to cancel this test?
          </h2>
          <div className="flex justify-end">
            <Button
              onClick={() => {
                cancelOrder();
              }}
              fullWidth
              disabled={isCancelLoading}
              loading={isCancelLoading}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default ReasonListScreen;
